import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Ticket.css";
import "./menu3.css";
axios.defaults.withCredentials = true;

const CreateTickets = () => {
  const [isAddressLoading] = useState(false);
  const [addressOptions, setAddressOptions] = useState([]);
  const [helpTopic, setHelpTopic] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [severityLevel, setSeverityLevel] = useState("");
  const [sla, setSla] = useState("Silver (5x8xNBD)");
  const [userDetails, setUserDetails] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState("");
  const [customerList, setCustomerList] = useState([]);
  const [formData, setFormData] = useState({
    email: "",
    fullName: "",
    position: "",
    phoneNumber: "",
    address: "",
    issueSummary: "",
    issueDetails: "",
    fileupload: [],
    files: [],
    severityLevel: "",
    sla: "Platinum (7x24x4)",
  });

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const res = await axios.get("/customer/v2", {
          withCredentials: true,
        });
        setCustomerList(res.data.customers);
      } catch (error) {
        console.error("Error fetching customer list:", error);
      }
    };
    fetchCustomers();
  }, []);

useEffect(() => {
  const fetchUserDetails = async () => {
    try {
      const res = await axios.get("/customer", {
        withCredentials: true,
        validateStatus: s => s >= 200 && s < 500,
      });

      const user = res.status === 200 ? (res.data?.user || null) : null;
      setUserDetails(user);

      if (!user) {
        setFormData(prev => ({
          ...prev,
          email: "",
          fullName: "",
          phoneNumber: "",
          position: "",
          company: "",
          address: "",
        }));
        setAddressOptions([]);
        return;
      }

      setFormData(prev => ({
        ...prev,
        email: user.email || "",
        fullName: user.name || "",
        phoneNumber: user.phone || "",
        position: user.position || "",
        company: user.company_name  || "",
      }));
      setAddressOptions(user.addressList || []);
    } catch (err) {
      console.error("Error fetching user details:", err);
      setUserDetails(null);
      setAddressOptions([]);
    }
  };
  fetchUserDetails();
}, []);


  const fetchCustomerDetails = async (selectedId) => {
    try {
      const res = await axios.get(
        `/customer/${selectedId}`,
        {
          withCredentials: true,
          validateStatus: (s) => s >= 200 && s < 500,
        }
      );

      const user = res.data?.user || null;
      setUserDetails(user);

      if (!user) {
        setFormData((prev) => ({
          ...prev,
          email: "",
          fullName: "",
          phoneNumber: "",
          position: "",
          company: "",
          address: "",
        }));
        setAddressOptions([]);
        return;
      }

      setFormData((prev) => ({
        ...prev,
        email: user?.email || "",
        fullName: user?.name || "",
        phoneNumber: user?.phone || "",
        position: user?.position || "",
        company: user?.company_name  || "",
      }));
      setAddressOptions(user?.addressList || []);
      setFormData((prev) => ({ ...prev, address: "" }));
    } catch (err) {
      console.error("Error fetching customer details:", err);
      setUserDetails(null);
      setAddressOptions([]);
    }
  };

  const handleHelpTopicChange = (e) => {
    const selectedHelpTopic = e.target.value;
    setHelpTopic(selectedHelpTopic);
    setSeverityLevel(
      selectedHelpTopic === "Feedback and General Questions"
        ? "low"
        : selectedHelpTopic === "Report Hardware /Software System Down"
        ? "high"
        : "medium"
    );
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [id]: value }));
  };

  const handleFileChange2 = (event) => {
    const files = Array.from(event.target.files);
    if (files.length + selectedFiles.length > 7) {
      alert("คุณสามารถอัปโหลดไฟล์ได้ไม่เกิน 7 ไฟล์เท่านั้น");
    } else {
      setSelectedFiles((prev) => [...prev, ...files]);
    }
  };
  const resetForm = () => {
    setFormData({
      issueSummary: "",
      password: "",
      confirmPassword: "",
      issueDetails: "",
      severityLevel: "",
      sla: "",
      fileupload: [],
      files: [],
    });
    setHelpTopic("");
    setSelectedFiles([]);
  };

  const submitForm = async () => {
  if (isSubmitting) return;
  setIsSubmitting(true);

  const ownerId = userDetails?.id || selectedCustomerId || "";
  if (!ownerId) {
    alert("ไม่พบข้อมูลผู้ใช้สำหรับผูก Ticket (ownerId ว่าง)");
    setIsSubmitting(false);
    return;
  }

  const formDataObj = new FormData();
  formDataObj.append("id", ownerId);
  formDataObj.append("customer_address_id", formData.address);
  formDataObj.append("helpTopic", helpTopic);
  formDataObj.append("issueSummary", formData.issueSummary);
  formDataObj.append("severityLevel", severityLevel);
  formDataObj.append("sla", sla);
  formDataObj.append("issueDetails", formData.issueDetails);

  selectedFiles.forEach((file) => formDataObj.append("attachedFiles", file));

  try {
    const res = await axios.post("/ticketcustomer/admin", formDataObj, {
      withCredentials: true,
      headers: { "Content-Type": "multipart/form-data" },
      validateStatus: s => s >= 200 && s < 500,
    });

    if (res.status >= 400) {
      const msg = res.data?.message || JSON.stringify(res.data) || "Request failed";
      alert("An error occurred: " + msg);
      return;
    }

    alert(`Ticket created successfully! Your ticket number is ${res.data?.ticketNumber}`);
    resetForm();
    const fileInput = document.getElementById("fileupload");
    if (fileInput) fileInput.value = "";
    window.location.reload();
  } catch (error) {
    alert("An error occurred: " + (error?.message || "Unknown error"));
  } finally {
    setIsSubmitting(false);
  }
};

  const handleSeverityLevelsChange = (e) => {
    setSeverityLevel(e.target.value);
  };

  return (
    <>
      <div className="ticket-main-content">
        <div className="ticket-form-container">
          <h2>Open a New Ticket</h2>
          <p>Please fill in the form below to open a new ticket.</p>
          <div className="form-group">
            <label>Select Customer Name:</label>
            <select
              value={selectedCustomerId}
              onChange={(e) => {
                const selectedId = e.target.value;
                setSelectedCustomerId(selectedId);
                if (selectedId) {
                  fetchCustomerDetails(selectedId);
                } else {
                  setUserDetails(null);
                  setFormData((prev) => ({
                    ...prev,
                    email: "",
                    fullName: "",
                    phoneNumber: "",
                    position: "",
                  }));
                  setAddressOptions([]);
                }
              }}
            >
              <option value="">-- Select Customer --</option>
              {(customerList || []).map((customer) => (
                <option key={customer.id} value={customer.id}>
                  {customer.company_name} ({customer.name})
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Email :</label>
            <input type="email" id="email" value={formData.email} readOnly />
          </div>
          <div className="form-group">
            <label>Full Name:</label>
            <input
              type="text"
              id="fullName"
              value={formData.fullName}
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Phone Number:</label>
            <input
              type="text"
              id="phoneNumber"
              value={formData.phoneNumber}
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Address:</label>
            {isAddressLoading ? (
              <div>Loading addresses...</div>
            ) : (
              <select
                id="address"
                value={formData.address || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    address: Number(e.target.value),
                  }))
                }
                className="w-full p-2 border rounded mb-2"
              >
                <option value="" disabled>
                  -- โปรดเลือกที่อยู่ --
                </option>
                {addressOptions.map((address) => (
                  <option key={address.id} value={address.id}>
                    {address.address}
                  </option>
                ))}
              </select>
            )}
          </div>

          <div className="form-group">
            <label>Help Topic:</label>
            <select
              id="help-topic"
              value={helpTopic}
              onChange={handleHelpTopicChange}
              className="help-topic-select"
            >
              <option value="">Select a Help Topic</option>
              <option value="Feedback and General Questions">
                Feedback and General Questions
              </option>
              <option value="Report Hardware / Software Performamce Issue">
                Report Hardware / Software Performance Issue
              </option>
              <option value="Report Hardware /Software System Down">
                Report Hardware / Software System Down
              </option>
            </select>
          </div>
          {helpTopic && (
            <>
              <div className="form-group">
                <label>Issue Summary:</label>
                <input
                  type="text"
                  id="issueSummary"
                  name="issueSummary"
                  value={formData.issueSummary}
                  onChange={handleInputChange}
                  placeholder="Brief summary of your issue"
                />
              </div>
              <div className="form-group">
                <label>Severity Levels:</label>
                <select
                  id="Severity-Levels"
                  value={severityLevel}
                  onChange={handleSeverityLevelsChange}
                  className="help-topic-select no-arrow"
                  disabled
                >
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                </select>
              </div>
              <div className="form-group">
                <label>SLA:</label>
                <select
                  id="Sla"
                  value={sla}
                  onChange={(e) => setSla(e.target.value)}
                  className="help-topic-select"
                >
                  <option value="Silver (5x8xNBD)">Silver (5x8xNBD)</option>
                  <option value="Gold (7x24xNBD)">Gold (7x24xNBD)</option>
                  <option value="Platinum (7x24x4)">Platinum (7x24x4)</option>
                </select>
              </div>
              <div className="form-group">
                <label>Details:</label>
                <textarea
                  id="issueDetails"
                  name="issueDetails"
                  value={formData.issueDetails}
                  onChange={handleInputChange}
                  placeholder="Provide details about the issue"
                />
              </div>
              <div className="form-group">
                <label>Attach Files:</label>
                <input
                  type="file"
                  id="fileupload"
                  multiple
                  onChange={handleFileChange2}
                />
                <ul>
                  {selectedFiles.length > 0 ? (
                    selectedFiles.map((file, index) => (
                      <li key={index}>{file.name}</li>
                    ))
                  ) : (
                    <li>ยังไม่ได้เลือกไฟล์</li>
                  )}
                </ul>
              </div>
              <div className="form-actions">
                <button
                  onClick={submitForm}
                  className="submit-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Processing..." : "Create Ticket"}
                </button>
                <button onClick={resetForm} className="reset-button">
                  Reset
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default CreateTickets;
